import { render, staticRenderFns } from "./AddItem.vue?vue&type=template&id=2f39c6a7&"
import script from "./AddItem.vue?vue&type=script&lang=ts&"
export * from "./AddItem.vue?vue&type=script&lang=ts&"
import style0 from "./AddItem.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports